export default __webpack_public_path__ + "static/media/Sclogo.f04fe6ed.svg";